module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Medium.e63313c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nca/css/font/NotoSansKR-Medium.woff
// module id = 4Kdc
// module chunks = 0